module.exports = __webpack_public_path__ + "static/media/galdinsPlayed_50000_100000.047cf374.png";